var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:{ 'is-highlighted': _vm.highlighted }},[_c('document-link',{attrs:{"document":_vm.document,"target":_vm.target}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }